import axios from 'axios'; // Import axios
import { useState } from 'react';
import Cookies from 'js-cookie'; // Import Cookies untuk menyimpan token
import { Link, useNavigate } from 'react-router-dom'; // Import useNavigate

export default function Signup() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    image_url: "",
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate(); // Initialize the navigate function

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.password || formData.password.length < 8)
      newErrors.password = "Password must be at least 8 characters";
    if (!formData.image_url) newErrors.image_url = "Profile image URL is required";
    // Optional: Validate email and URL format
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Email is not valid";
    else if (!/^https?:\/\/[^\s$.?#].[^\s]*$/.test(formData.image_url)) newErrors.image_url = "Image URL must be a valid URL";

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      axios.post("https://final-project-api-alpha.vercel.app/api/auth/register", formData)
        .then((response) => {
          if (response.data.token) {
            Cookies.set('token', response.data.token, { expires: 1 });
            Cookies.set('image_url', formData.image_url, { expires: 1 }); 
            alert("Signup successful!");

            navigate('/'); 
          } else {
            alert("Signup failed! Response from API: " + JSON.stringify(response.data));
          }
        })
        .catch((error) => {
 
          if (error.response) {

            console.error("Error Response Data:", error.response.data);
            console.error("Error Response Status:", error.response.status);
            console.error("Error Response Headers:", error.response.headers);
            alert("Error signing up: " + (error.response.data.message || "An unknown error occurred."));
          } else if (error.request) {

            console.error("Error Request Data:", error.request);
            alert("Error signing up: No response from server.");
          } else {

            console.error("General Error:", error.message);
            alert("Error signing up: " + error.message);
          }
        });
    }
  };

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm max-sm:mt-16">
        <div className="flex items-center justify-center">
          <svg
            width="30"
            height="30"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="logo-icon"
          >
            <g clipPath="url(#clip0_1504_3397)">
              <circle cx="16" cy="16" r="16" fill="#4640DE"></circle>
              <mask id="path-2-inside-1_1504_3397" fill="white">
                <path d="M16 28C18.6652 28 21.3304 25.8953 23.0607 24.179C23.4599 23.7831 22.9792 23.2122 22.4822 23.4749C20.6013 24.469 18.0181 25.6 16 25.6C13.9819 25.6 11.3987 24.469 9.5178 23.4749C9.02076 23.2122 8.54012 23.7831 8.93926 24.179C10.6696 25.8953 13.3348 28 16 28Z"></path>
              </mask>
              <path
                d="M23.0607 24.179L25.1734 26.3089L25.1734 26.3089L23.0607 24.179ZM8.93926 24.179L6.82658 26.3089L6.82658 26.3089L8.93926 24.179ZM9.5178 23.4749L10.9197 20.8226L10.9197 20.8226L9.5178 23.4749ZM22.4822 23.4749L21.0803 20.8226L21.0803 20.8226L22.4822 23.4749ZM20.948 22.0491C20.1783 22.8126 19.2652 23.5953 18.3201 24.1712C17.3491 24.7627 16.5672 25 16 25V31C18.098 31 19.9813 30.1849 21.4419 29.2951C22.9282 28.3895 24.2129 27.2616 25.1734 26.3089L20.948 22.0491ZM16 25C15.4328 25 14.6509 24.7627 13.6799 24.1712C12.7348 23.5953 11.8217 22.8126 11.052 22.0491L6.82658 26.3089C7.78708 27.2616 9.07177 28.3895 10.5581 29.2951C12.0187 30.1849 13.902 31 16 31V25ZM8.11593 26.1272C9.1314 26.6639 10.3827 27.2629 11.6934 27.7336C12.967 28.1911 14.4921 28.6 16 28.6V22.6C15.4899 22.6 14.7143 22.4434 13.7216 22.0868C12.7658 21.7436 11.7851 21.28 10.9197 20.8226L8.11593 26.1272ZM16 28.6C17.5079 28.6 19.033 28.1911 20.3066 27.7336C21.6173 27.2629 22.8686 26.6639 23.8841 26.1272L21.0803 20.8226C20.2149 21.28 19.2342 21.7436 18.2784 22.0868C17.2857 22.4434 16.5101 22.6 16 22.6V28.6ZM25.1734 26.3089C25.7674 25.7197 26.1776 24.8995 26.2071 23.9593C26.2356 23.0551 25.905 22.2526 25.4152 21.663C24.4114 20.4547 22.6321 20.0024 21.0803 20.8226L23.8841 26.1272C22.8293 26.6847 21.5389 26.3865 20.7999 25.4969C20.4425 25.0667 20.1883 24.4648 20.2101 23.7708C20.2331 23.0407 20.5536 22.4403 20.948 22.0491L25.1734 26.3089ZM11.052 22.0491C11.4464 22.4403 11.7669 23.0407 11.7899 23.7708C11.8117 24.4648 11.5575 25.0667 11.2001 25.4969C10.4611 26.3865 9.17068 26.6847 8.11593 26.1272L10.9197 20.8226C9.36787 20.0024 7.5886 20.4547 6.58483 21.663C6.09504 22.2526 5.76443 23.0551 5.79286 23.9593C5.82241 24.8995 6.23259 25.7197 6.82658 26.3089L11.052 22.0491Z"
                fill="white"
                mask="url(#path-2-inside-1_1504_3397)"
              ></path>
              <circle
                cx="15.8055"
                cy="14.1946"
                r="7.49047"
                transform="rotate(-90 15.8055 14.1946)"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></circle>
              <path
                d="M21.4043 8.98486L24.3334 6.04817"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </g>
            <defs>
              <clipPath id="clip0_1504_3397">
                <rect width="32" height="32" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>
        </div>
        <h2 className="mt-10 text-center text-2xl font-bold tracking-tight text-gray-900">
          Sign up for a new account
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-900"
            >
              Name
            </label>
            <div className="mt-2">
              <input
                id="name"
                name="name"
                type="text"
                required
                value={formData.name}
                onChange={handleChange}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border-2 border-slate-100 outline-1  outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm"
              />
              {errors.name && (
                <p className="text-red-500 text-xs">{errors.name}</p>
              )}
            </div>
          </div>

          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-900"
            >
              Email address
            </label>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border-2 border-slate-100 outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm"
              />
              {errors.email && (
                <p className="text-red-500 text-xs">{errors.email}</p>
              )}
            </div>
          </div>

          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-900"
            >
              Password
            </label>
            <div className="mt-2">
              <input
                id="password"
                name="password"
                type="password"
                required
                minLength="8"
                value={formData.password}
                onChange={handleChange}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border-2 border-slate-100 outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm"
              />
              {errors.password && (
                <p className="text-red-500 text-xs">{errors.password}</p>
              )}
            </div>
          </div>

          <div>
            <label
              htmlFor="image_url"
              className="block text-sm font-medium text-gray-900"
            >
              Profile Image URL
            </label>
            <div className="mt-2">
              <input
                id="image_url"
                name="image_url"
                type="url"
                required
                value={formData.image_url}
                onChange={handleChange}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border-2 border-slate-100 outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm"
              />
              {errors.image_url && (
                <p className="text-red-500 text-xs">{errors.image_url}</p>
              )}
            </div>
            <div className="mt-2">
              <button
                type="button"
                onClick={() =>
                  setFormData({
                    ...formData,
                    image_url:
                      "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?semt=ais_items_boosted&w=740",
                  })
                }
                className="text-indigo-600 hover:text-indigo-800 text-sm hover:underline"
              >
                Use General Profile Image
              </button>
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="w-full p-3 bg-indigo-600 text-white rounded-md"
            >
              Sign up
            </button>
          </div>
        </form>

        <p className="mt-10 text-center text-sm text-gray-500">
          Already a member?{" "}
          <Link
            to={"/login"}
            className="font-semibold text-indigo-600 hover:text-indigo-500"
          >
            Sign in here
          </Link>
        </p>
      </div>
    </div>
  );
}
